/**
 * Phase 1 route exports.
 *
 * Plan 01-08 created stub routes (`<div data-route='...'/>`) so the
 * React Router shell could be type-checked and navigated before feature
 * plans landed.  Each plan replaces its stub here with the real
 * component re-exported from the feature tree.
 *
 * Still-stubbed routes identify the plan that will replace them.
 */
import { OnboardingWizard } from './features/onboarding/OnboardingWizard';
import { LoginRoute as LoginRouteImpl } from './features/login/LoginRoute';
import { DashboardRoute as DashboardRouteImpl } from './features/dashboard/DashboardRoute';
import { SettingsRoute as SettingsRouteImpl } from './features/settings/SettingsRoute';
import { useTranslation } from 'react-i18next';
import { AdminDashboardPanel } from './features/admin/AdminDashboardPanel';
import { ScreenHeader } from './components/ScreenHeader';
import { CONSOLE_MAIN } from './features/parents/ParentConsoleRoute';
// Plan 06-03: /installer is the iOS install walkthrough — unauthenticated by
// design (D-05). Re-exported from this barrel so App.tsx imports it next to
// the rest of the route surface.
import { InstallRoute as InstallRouteImpl } from './features/install/InstallRoute';
export { InstallRouteImpl as InstallRoute };

// Plan 01-13: DashboardRoute — IdleMode + InteractiveMode dual-mode shell.
export { DashboardRouteImpl as DashboardRoute };

// Plan 01-11: OnboardingWizard — step-:n wizard with allergy confirmation.
export function OnboardingRoute() {
  return <OnboardingWizard />;
}

// Plan 01-12: LoginRoute — passordskjema, eller avatarer + PIN på innrullert
// kjøkkenskjerm (#142).
export { LoginRouteImpl as LoginRoute };

// Plan 01-13: SettingsRoute — authenticated shell + GET /api/auth/me guard.
export { SettingsRouteImpl as SettingsRoute };

// Plan 06-04 SC-5: AdminSettingsRoute viser det samlede <AdminDashboardPanel>.
// #159 (steg 9c): samme panel som System-fanen på /foreldre, under en
// ScreenHeader «Administrasjon» med tilbakeknapp til Meg. Skallet tegner ikke
// sin egen topp her (drawsOwnHeader).
export function AdminSettingsRoute() {
  const { t } = useTranslation();
  return (
    <main
      data-route="admin-settings"
      className={CONSOLE_MAIN}
    >
      <ScreenHeader title={t('admin.panel.heading')} back={{ to: '/settings' }} />
      <AdminDashboardPanel />
    </main>
  );
}

// Not a feature-plan stub — exists permanently as the catch-all.
export function NotFoundRoute() {
  return <div data-route="not-found" />;
}
